import { LAYOUTS } from '@voltmoney/types';
import { HeaderTypeTokens, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { AadharInitAction, BajajAadharInitAction, clearPollarAction, closeLoaderAction, digilockerAction, digiLockerModeInit, digioCallback, failedVerification, GoBackAction, needHelpAction, successVerification, } from './actions';
import { getContactUsDetails, getLenderIcon, getLenderInfo, horizontalStepperRepo, isFromJupiter, removeUrlWithoutReload } from '../../../configs/utils';
import { Platform } from "react-native";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { LENDER_ID } from "../../../configs/constants";
export const template = (stepper, shouldShowDocUploadOption, isFromTata, lenderInfo, showSuccessModal, successTitle, successSubTitle, successButtonTitle, showFailedModal, failedTitle, failedSubTitle, failedButtonTitle, height, isLenderBajaj, KycMode, successLottie, showCancelledModal, showAddressMismatchCard, showInProgressCard, isJupiter, loading, currentStepId, contactUsDetails, isFromDigioModal) => {
    return {
        layout: {
            id: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
            type: LAYOUTS.LIST,
            widgets: [
                { id: 'renderDigioCard', type: WIDGET.KYC_DIGIO_CARD },
            ],
        },
        datastore: {
            renderDigioCard: {
                headerTitle: 'KYC verification',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                lenderInfo: lenderInfo,
                lenderIcon: getLenderIcon(lenderInfo?.lenderAccountId),
                backAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {},
                },
                needHelpAction: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {}
                },
                aadharInitAction: KycMode === 'BAJAJ' ? {
                    type: ACTION.BAJAJ_DIGIO_INIT,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {}
                } : KycMode === "DIGILOCKER" ? {
                    type: ACTION.DIGI_LOCKER_MODE,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {}
                } : {
                    type: ACTION.AADHAR_INIT,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {},
                },
                continueAction: {
                    type: ACTION.SUCCESS_VERIFICATION,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: { currentStepId },
                },
                failureAction: {
                    type: ACTION.FAILED_VERIFICATION,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {},
                },
                shouldShowDocUploadOption: shouldShowDocUploadOption,
                documentUploadAction: {
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    type: ACTION.DOCUMENT_UPLOAD,
                    payload: {}
                },
                successCard: showSuccessModal,
                failedCard: showFailedModal,
                successTitle,
                successSubTitle,
                successButtonTitle,
                failedTitle,
                failedSubTitle,
                failedButtonTitle,
                height,
                successLottieFromMF: successLottie,
                lenderName: lenderInfo?.lenderAccountId,
                showCancelledModal: showCancelledModal,
                showAddressMismatchCard: showAddressMismatchCard,
                showInProgressCard: false,
                isFromJupiter: isJupiter,
                loading: loading,
                closeLoaderAction: {
                    type: ACTION.CLOSE_LOADER,
                    routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE,
                    payload: {}
                },
                currentStepId: currentStepId,
                contactUsDetails,
            },
        },
    };
};
export const kycDigioMf = {
    onLoad: async ({ instrumentTrack, setDatastore, network, getHeight, removeWidgets, ...rest }, { showSuccessModal, successTitle, successSubTitle, successButtonTitle, showFailedModal, failedTitle, failedSubTitle, failedButtonTitle, successLottie, showCancelledModal, showAddressMismatchCard, showInProgressCard, loading, setIsUserLoggedIn, currentStepId, isFromDigioModal, clearPollar }) => {
        Platform.OS === 'web' ? removeUrlWithoutReload("message") : {};
        removeWidgets(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, [
            { id: "renderDigioCard", type: WIDGET.KYC_DIGIO_CARD }
        ]);
        removeWidgets(ROUTE.DIGIO_MODAL, [
            { id: 'digio', type: WIDGET.KYC_DIGIO_MOBILE }
        ]);
        const contactUsDetails = await getContactUsDetails();
        const userContextResponse = await SharedPropsService.getUser();
        setIsUserLoggedIn(userContextResponse);
        let applicationId = '';
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
            const userApplication = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
            userContextResponse.linkedApplications[0] = userApplication.data;
            await SharedPropsService.setUser(userContextResponse);
        }
        else {
            applicationId = userContextResponse.linkedApplications[0].applicationId;
        }
        const userDetails = userContextResponse;
        // update the user context with the latest application details
        await SharedPropsService.setUser(userContextResponse);
        const isFromTata = userDetails.linkedApplications[0].lenderAccountId === "Tata";
        instrumentTrack("KYC_START_PAGE_VIEWED", { "type": isFromTata ? "Tata Digilocker" : "Bajaj Digilocker" });
        const isLenderBajaj = userDetails?.linkedApplications[0]?.lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
        if (userDetails?.linkedApplications[0]?.lenderAccountId.toLowerCase() === LENDER_ID.DSP) {
            // @ts-ignore
            window?.AndroidInterface?.postMessage("DSP");
            // @ts-ignore
            window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("DSP");
            // @ts-ignore
            window?.ReactNativeWebView?.postMessage("DSP");
            // @ts-ignore
            window?.top?.postMessage("DSP");
        }
        const routeConfigResponse = await network.post(api.routeConfigNameMisMatch, {
            applicationId: applicationId
        }, {
            headers: await getAppHeader()
        });
        const getKYCModeResponse = await network.get(`${api.getKYCMode}${applicationId}`, {
            headers: await getAppHeader()
        });
        const KycMode = getKYCModeResponse?.data;
        const shouldShowDocUploadOption = routeConfigResponse.data.routeModel.routeOptions.shouldShowDocUploadOption;
        const stepper = await horizontalStepperRepo(network);
        const lenderInfo = await getLenderInfo(network);
        const isJupiter = await isFromJupiter();
        return Promise.resolve(template(stepper, shouldShowDocUploadOption, isFromTata, lenderInfo, showSuccessModal, successTitle, successSubTitle, successButtonTitle, showFailedModal, failedTitle, failedSubTitle, failedButtonTitle, getHeight(), isLenderBajaj, KycMode, successLottie, showCancelledModal, showAddressMismatchCard, showInProgressCard, isJupiter, loading, currentStepId, contactUsDetails, isFromDigioModal));
    },
    actions: {
        [ACTION.AADHAR_INIT]: AadharInitAction,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.DOCUMENT_UPLOAD]: digilockerAction,
        [ACTION.DIGIO_ANDROID_CALLBACK]: digioCallback,
        [ACTION.BAJAJ_DIGIO_INIT]: BajajAadharInitAction,
        [ACTION.DIGI_LOCKER_MODE]: digiLockerModeInit,
        [ACTION.CLOSE_LOADER]: closeLoaderAction,
        [ACTION.CLOSE_POLLAR]: clearPollarAction,
    },
};
